import { useContext } from 'react';

import { MenuStateContext } from '../../containers';

const useMenu = () => {
    const context = useContext(MenuStateContext);
    return context;
};
export default useMenu;
